import React from "react";
import Login from "../Components/user/Login";


const LoginPage = () => {
    return (
        <div className="">
            <Login />
        </div>
    )
};


export default LoginPage;